// Global
export const APP_INIT = 'APP_INIT';
export const APP_ERROR = 'APP_ERROR';

// BUILD NOTIFICATION
export const BuildNotification = {
    NOTSTARTED: 'NOTSTARTED',
    BUILDING: 'BUILDING',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED',
};

export const TaxpayerProfileActions = {
    InviteUser: 'InviteUser',
    NotificationPreferences: 'NotificationPreferences',
    AddERP: 'AddERP',
    EditERP: 'EditERP',
    RegenerateSecrets: 'RegenerateSecrets',
    VerifyEmail: 'VerifyEmail',
    VerifyMobile: 'VerifyMobile',
    VerifyEmailMobile: 'VerifyEmailMobile',
    EditUSER: 'EditUSER',
    BlockUSER: 'BlockUSER',
    UnBlockUSER: 'UnBlockUSER',
    AddIntermediary: 'AddIntermediary'
};

export const LanguagesCodes = {
    En: '1',
    Ar: '2',
};

export const StatusCodes = {
    Active: '1',
    InActive: '2',
};

export const Languages = {
    En: 'en',
    Ar: 'ar'
};

export const POSStatus = {
    Pending: 0,
    InActive: 1,
    Active: 2,
    Retiring : 3,
    Retired : 4
};

export const Roles = {
    All: 'All',
    NormalDelegate: 'NormalDelegate',
    AdminDelegate: 'AdminDelegate',
    EtaAdmin: 3,
    None: 'None',
    ProcessAdministrators: 'ProcessAdministrators',
    ITOperator: 'ITOperators',
    DataAnalyst: 'DataAnalysts',
    GovDecisionMaker: 'GovDecisionMakers',
    SystemAuditor: 'SystemAuditors',
    TaxAuditor: 'TaxAuditors',
    ServiceCentreAssistants: 'ServiceCenterAssistants',
};

export const Icons = {
    MoreVertical: 'MoreVertical',
    UserData: 'UserOptional',
    Contact: 'Contact',
    Add: 'Add',
    Edit: 'Edit',
    Info: 'Info',
    Cancel: 'Cancel',
    CirclePlus: 'CirclePlus',
    ChevronRight: 'ChevronRight',
    ChevronDownMed: 'ChevronDownMed',
    EditContact: 'EditContact',
    Block: 'Blocked',
    AddFriend: 'AddFriend',
    BackToWindow: 'BackToWindow',
    Clear: 'Clear',
    Save: 'Save',
    View: 'View',
    Eye: 'Eye',
};

export const UserType = {
    Admin: 1,
    User: 2,
};

export const Actions = {
    EditERP: 'EditERP',
    RegenerateSecrets: 'RegenerateSecrets',
    EditUSER: 'EditUSER',
    BlockUSER: 'BlockUSER',
    UnBlockUSER: 'UnBlockUSER',
    ViewDetails: 'ViewDetails',
    Edit: 'Edit',
    Deactivate: 'Deactivate',
    Reactivate: 'Reactivate',
    ClearFilters: 'ClearFilters',
    Export: 'Export',
    ReportIssue: 'ReportIssue',
    Retire:'Retire'
};
export const Defaults = {
    AutoDismissPeriod : 15000,   
    NationalIDlength: 14,
    PageSize: 10 ,
    ResendOTP: 90, // in second
};

export const NotificationDialogResponseDelay = {
    Delay : 1000,    
};

export const MarkDownType = {
    Full: 'Registration_Full',
    Important: 'Registration_Important',
    Informative: 'Registration_Inform',
    Terms: 'Registration_Terms',

    RegistrationPrivacy: 'Registration_Privacy',
    SelfRegisterConditions: 'SelfRegister_Conditions'
};

export const Dates = {
    Date: 'DD/MM/YYYY',
};
